export const PROFORM_EDGE_SIDES = ['top', 'right', 'bottom', 'left'] as const;

const copy = {
  cs: {
    edges: 'Hrany',
    sides: { top: 'Horní', right: 'Pravá', bottom: 'Dolní', left: 'Levá' },
    unavailable: 'Náhled hrany není dostupný',
    handleUnavailable: 'Pro zvolenou úchytku, umístění nebo rozměr není dostupný model',
  },
  sk: {
    edges: 'Hrany',
    sides: { top: 'Horná', right: 'Pravá', bottom: 'Dolná', left: 'Ľavá' },
    unavailable: 'Náhľad hrany nie je dostupný',
    handleUnavailable: 'Pre zvolenú úchytku, umiestnenie alebo rozmer nie je dostupný model',
  },
  en: {
    edges: 'Edges',
    sides: { top: 'Top', right: 'Right', bottom: 'Bottom', left: 'Left' },
    unavailable: 'Edge preview is unavailable',
    handleUnavailable: 'No model is available for the selected handle, placement or dimensions',
  },
} as const;

export function getProformEdgePreviewCopy(locale: string) {
  return copy[locale as keyof typeof copy] ?? copy.en;
}
